export default __webpack_public_path__ + "static/commercial-19deb484dd60ae20e05d80929a3af41d.png";